// A tool result (or subagent step summary) reads as a failure only when it
// explicitly says so; JSON payloads, plain text, etc. all count as success.
// Shared by the tool-call status icon and the subagent step icons so the two
// heuristics can't drift apart.
export function isToolError(value: string | undefined): boolean {
  if (!value) return false;
  const s = value.trim().toLowerCase();
  return (
    s.startsWith("error") ||
    s.startsWith("there was an error") ||
    s.startsWith("failed") ||
    s.startsWith("traceback")
  );
}
